<article #resizeableContainer id="editor" [appResizeObserver]="resizeableContainer" (resized)="canvasResized($event.contentRect.width - 50, $event.contentRect.height)">
  <canvas #canvas id="viewer"></canvas>
  <aside id="toolbox">
    <button mat-icon-button class="close-btn" (click)="closeEditor()">
      <mat-icon>close</mat-icon>
    </button>

    <nav class="tool-button-container">
      <button id="saveBtn" (click)="saveDrawingBtnAction()" [class.active]="savingAnnotations" [disabled]="!canUndo || !!this.editingAnnotation">
        <mat-icon>save</mat-icon>
      </button>
      <hr />
      <button id="colorPickerBtn">
        <input
          type="color"
          [value]="currentColor"
          [disabled]="savingAnnotations || !!this.editingAnnotation"
          [style.background]="currentColor"
          (change)="updateColor($event)"
          />
      </button>

      <hr />

      <button id="panBtn" (click)="stopDrawing()" [class.active]="currentPen === null" [disabled]="savingAnnotations || !!this.editingAnnotation">
        <mat-icon>open_with</mat-icon>
      </button>
      <button id="textBtn" (click)="startDrawing('text')" [class.active]="currentPen === 'text'" [disabled]="savingAnnotations || !!this.editingAnnotation">
        <mat-icon>title</mat-icon>
      </button>
      <button id="freeLineBtn" class="sibling" (click)="startDrawing('free')" [class.active]="currentPen === 'free'" [disabled]="savingAnnotations || !!this.editingAnnotation">
        <mat-icon>gesture</mat-icon>
      </button>
      <button id="circleBtn" class="sibling" (click)="startDrawing('circle')" [class.active]="currentPen === 'circle'" [disabled]="savingAnnotations || !!this.editingAnnotation">
        <mat-icon>circle</mat-icon>
      </button>
      <button id="squareBtn" class="sibling" (click)="startDrawing('square')" [class.active]="currentPen === 'square'" [disabled]="savingAnnotations || !!this.editingAnnotation">
        <mat-icon>square</mat-icon>
      </button>
      <button id="rulerBtn" class="sibling" (click)="startDrawing('ruler')" [class.active]="currentPen === 'ruler'" [disabled]="savingAnnotations || !!this.editingAnnotation">
        <mat-icon>straighten</mat-icon>
      </button>

      <button id="undoBtn" (click)="undo()" [disabled]="!canUndo || savingAnnotations || !!this.editingAnnotation">
        <mat-icon>undo</mat-icon>
      </button>
      <button id="redoBtn" class="sibling" (click)="redo()" [disabled]="!canRedo || savingAnnotations || !!this.editingAnnotation">
        <mat-icon>redo</mat-icon>
      </button>

      <hr />
      <button id="zoomBtn" matTooltip="{{ 'commons.btn.zoom.reset' | translate }}" (click)="resetZoom()" [disabled]="!canReset || !!this.editingAnnotation">
        <mat-icon>zoom_out_map</mat-icon>
      </button>
      <button id="zoomInBtn" class="sibling" matTooltip="{{ 'commons.btn.zoom.in' | translate }}" (click)="zoomIn()" [disabled]="!canZoomIn || !!this.editingAnnotation">
        <mat-icon>add</mat-icon>
      </button>
      <button id="zoomOutBtn" class="sibling" matTooltip="{{ 'commons.btn.zoom.out' | translate }}" (click)="zoomOut()" [disabled]="!canZoomOut || !!this.editingAnnotation">
        <mat-icon>remove</mat-icon>
      </button>
    </nav>
  </aside>
</article>

@if (editingAnnotation) {
  <section [style.left]="(editingAnnotation.screenOrigin.x || 0) + 'px'" [style.top]="(editingAnnotation.screenOrigin.y || 0) + 'px'" class="user-input-prompt">
    <input id="userTextInput" matInput [(ngModel)]="editingAnnotation.text" [style.color]="editingAnnotation.color" [style.fontSize]="editingAnnotation.fontSize + 'px'" />
    <mat-select id="fontSizeInput" [(ngModel)]="editingAnnotation.fontSize">
      @for (size of fontSizes(); track size) {
        <mat-option [value]="size">{{ size }}</mat-option>
      }
    </mat-select>
    <button id="fontColorPickerBtn">
      <input type="color" [value]="currentColor" [style.background]="currentColor" (change)="updateColor($event)" />
    </button>
    <button id="cancelBtn" mat-icon-button (click)="cancelPrompt()">
      <mat-icon>close</mat-icon>
    </button>
    <button id="doneBtn" mat-icon-button color="primary" (click)="closePrompt()">
      <mat-icon>done</mat-icon>
    </button>
  </section>
}
